export const SET_CHALLENGES = "SET_CHALLENGES";
export const SET_MY_CHALLENGES = "SET_MY_CHALLENGES";
export const ADD_CHALLENGE = "ADD_CHALLENGE";
export const SET_MY_CHALLENGES_HISTORIES = "SET_MY_CHALLENGES_HISTORIES";
export const SET_CHALLENGES_CACHED = "SET_CHALLENGES_CACHED";
